// AI Generated Test
import { Component, Input, OnInit } from '@angular/core';
import { DataPrivacyService } from '../../services/data-privacy/data-privacy.service';
import { HelpCenterRepoService } from '../../services/api/help-center-repo/help-center-repo.service';

@Component({
    selector: 'privacy-dialogs-help-center',
    standalone: false,
    template: `
        <div class="data-privacy" id="privacy-help-center">
            <div class="mon-dialog-header">
                <page-header
                    [panelClass]="'row'"
                    [header]="'Data Privacy Help Center' | translate"
                    [panelLeftClass]="'col-48 pt-2'">
                </page-header>
            </div>

            <div class="mon-dialog-body">
                <div class="card panel-monsido-card mr-3 ml-3 mt-3">
                    <div class="card-header d-flex align-items-center">
                        <mon-data-privacy-info-type-icon
                            [monGroup]="infoType.group"
                            [monPriority]="infoType.priority">
                        </mon-data-privacy-info-type-icon>
                        <h2 class="ml-1 font-weight-300">
                            {{ infoType.name | translate }}
                        </h2>
                    </div>
                    <div class="card-body data-privacy-help-center-data">
                        <h3 translate>Issue type</h3>
                        <span>{{ formatText(infoType.group || 'other') }}</span>
                        <h3 translate>Severity</h3>
                        <span>{{ formatText(infoType.priority) }}</span>
                        <mon-data-privacy-severity-level [monPriority]="infoType.priority"></mon-data-privacy-severity-level>
                        <h3 *ngIf="infoType.regulations && infoType.regulations.length > 0" translate>Data Regulations</h3>
                        <span>{{ formatTextArray(infoType.regulations, true) }}</span>
                        <h3 *ngIf="infoType.regions && infoType.regions.length > 0" translate>Country</h3>
                        <span>{{ formatTextArray(infoType.regions, false) }}</span>
                        <div class="data-privacy-help-center-description-container" *ngIf="infoType.description">
                            <h3 class="mt-0" translate>Description</h3>
                            <div [innerHTML]="infoType.description"></div>
                        </div>
                        <h3 *ngIf="infoType.how_to_mitigate" translate>How to prevent</h3>
                        <div [innerHTML]="infoType.how_to_mitigate"></div>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class PrivacyDialogsHelpCenterComponent implements OnInit {
    @Input() infoType: any = {};

    constructor (
        private dataPrivacyService: DataPrivacyService,
        private helpCenterRepoService: HelpCenterRepoService,
    ) {}

    ngOnInit (): void {
        this.infoType.description = '';
        this.infoType.how_to_mitigate = '';

        const params = {
            identifier: this.infoType.identifier,
        };

        this.helpCenterRepoService.get(params).then((res: any) => {
            if (Array.isArray(res) && res.length > 0) {
                this.infoType.description = res[0].description;
                this.infoType.how_to_mitigate = res[0].how_to_mitigate;
            }
        });
    }

    formatText = (text: string): string => {
        return this.dataPrivacyService.formatText(text);
    };

    formatTextArray = (array: any[], param: boolean): string => {
        return this.dataPrivacyService.formatTextArray(array, param);
    };
}
